import { render, staticRenderFns } from "./SampleVideo.vue?vue&type=template&id=dcf49722&scoped=true"
import script from "./SampleVideo.vue?vue&type=script&lang=js"
export * from "./SampleVideo.vue?vue&type=script&lang=js"
import style0 from "./SampleVideo.vue?vue&type=style&index=0&id=dcf49722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf49722",
  null
  
)

export default component.exports